import { render, staticRenderFns } from "./Quadtych.vue?vue&type=template&id=6204a4d9&scoped=true&"
import script from "./Quadtych.vue?vue&type=script&lang=ts&"
export * from "./Quadtych.vue?vue&type=script&lang=ts&"
import style0 from "./Quadtych.vue?vue&type=style&index=0&id=6204a4d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6204a4d9",
  null
  
)

export default component.exports